/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ENGINEERING NOTES
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        1) Do not import the following into this class:
            1) '/ezlibrary/enums/EzEnumerations.js';
            2) '/ezlibrary/helpers/EzHelpers.js' or any helper classes
            3) '/ezlibrary/exceptions/EzExceptions.js'
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/

import { EzException } from '/ezlibrary/exceptions/EzException.js';

/**
 * @class
 * @extends {EzException}
 * @description
 * Exception for serialization errors
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * ENGINEERING NOTES:
 *     1) Do not import this class into /ezlibrary/ezclocker-classes/EzClasses.js
 *        import group module because EzException is alredy exported by the
 *        /ezlibrary/exceptions/EzExceptions.js import group module.
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with:
 *     import {
 *         EzException,
 *         // EzExceptionInClassMethod,
 *         // EzBadParamException,
 *         // EzBadStateException,
 *         // EzStaticClassException,
 *         // EzNotSupportedException
 *     } from '/ezlibrary/exceptions/EzExceptions.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzSerializationException extends EzException {
    /**
     * @override
     * Override the constructor for EzSerializationException
     * Creates a new instance of EzSerialziationException
     *
     * @param {string} message
     * Default is 'An unexpected error occurred.'
     * @param {undefined|null|object|any} options
     * Default is null.
     */
    constructor(message = EzException.DEFAULT_ERROR_MESSAGE, options = null) {
        super(
            'string' === typeof message && 0 < message?.length
                ? message
                : EzException.DEFAULT_ERROR_MESSAGE,
            options || EzException.ezBuildDefaultOptions(this));
    }
}